import { render } from "./AmCharts.vue?vue&type=template&id=f6c9235e&ts=true"
import script from "./AmCharts.vue?vue&type=script&lang=ts"
export * from "./AmCharts.vue?vue&type=script&lang=ts"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__